import { createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface ApiKeyState {
    apiKey: string | null;
}

const initialState: ApiKeyState = {
    apiKey: null,
}

const apiKeySlice = createSlice({
    name: 'apiKey',
    initialState,
    reducers: {
        setApiKey(state, action: PayloadAction<string>) {
            state.apiKey = action.payload;
        }
    }
});

export const {setApiKey} = apiKeySlice.actions;
export default apiKeySlice.reducer;